import { IonicVueRouter } from '@ionic/vue';
import Vue from 'vue';
import firebase from 'firebase';

Vue.use(IonicVueRouter);

let router = new IonicVueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'dashboard',
      meta: {
        requiresAuth: true
      },
      component: () => import( /* webpackChunkName: "dashboard" */ './views/Dashboard.vue')
    },
    {
      path: '/login',
      name: 'login',
      meta: {
        requiresGuest: true
      },
      component: () => import( /* webpackChunkName: "login" */ './views/Login.vue')
    },
    {
      path: '/recover',
      name: 'recover',
      meta: {
        requiresGuest: true
      },
      component: () => import( /* webpackChunkName: "recover" */ './views/Recover.vue')
    },
    {
      path: '/support',
      name: 'support',
      meta: {
        requiresAuth: true
      },
      component: () => import( /* webpackChunkName: "support" */ './views/Support.vue')
    },
    {
      path: '/account',
      name: 'account',
      meta: {
        requiresAuth: true
      },
      component: () => import( /* webpackChunkName: "account" */ './views/Account.vue')
    },
    {
      path: '/earnings',
      name: 'earnings',
      meta: {
        requiresAuth: true
      },
      component: () => import( /* webpackChunkName: "earnings" */ './views/Earnings.vue')
    },
    {
      path: '/daily-earnings/:startDate/:endDate',
      name: 'daily-earnings',
      meta: {
        requiresAuth: true
      },
      component: () => import( /* webpackChunkName: "daily-earnings" */ './views/DailyEarnings.vue')
    },
    {
      path: '/shifts',
      name: 'shifts',
      meta: {
        requiresAuth: true
      },
      component: () => import( /* webpackChunkName: "shifts" */ './views/Shifts.vue')
    },
    {
      path: '/resources',
      name: 'resources',
      meta: {
        requiresAuth: true
      },
      component: () => import( /* webpackChunkName: "resources" */ './views/Resources.vue')
    },
    {
      path: '/display-name',
      name: 'display-name',
      // meta: {
      //   requiresAuth: true
      // },
      component: () => import( /* webpackChunkName: "resources" */ './views/DisplayName.vue')
    },
    {
      path: '/updating',
      name: 'updating',
      // meta: {
      //   requiresAuth: true
      // },
      component: () => import( /* webpackChunkName: "resources" */ './views/Updating.vue')
    }
  ]
});

router.beforeEach((to, from, next) => {
  // Check for required auth guard
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // Check if not logged in
    if (!firebase.auth().currentUser) {
      // Go to login
      next({
        path: '/login',
        query: {
          redirect: to.fullPath
        }
      });
    } else {
      // Proceed to route
      // At this point the user is logged in, check if a display name is set, if it's not set
      // Throw up a page to ask for it
      if(!firebase.auth().currentUser.displayName) {
        next({
          path: 'display-name',
          query: {
            redirect: to.fullPath
          }
        })
      }
      next();
    }
  } else if (to.matched.some(record => record.meta.requiresGuest)) {
    if (firebase.auth().currentUser) {
      // Go to home
      next({
        path: '/',
        query: {
          redirect: to.fullPath
        }
      });
    }
    else {
      // Proceed to route
      next();
    }
  }
  else {
    // Proceed to route
    next();
  }
});

export default router;

